import * as React from "react";
const SvgReport = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" data-name="Trazado 197" style={{
    fill: "none"
  }} /><path d="M12 5.99 19.53 19H4.47zM12 2 1 21h22zm1 14h-2v2h2zm0-6h-2v4h2z" data-name="Trazado 198" style={{
    fill: "rgba(10,4,6,.4)"
  }} /></svg>;
export { SvgReport as ReactComponent };